import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import {Observable} from 'rxjs';
import {AngularFirestore} from "@angular/fire/firestore";
import {first, map, tap} from "rxjs/operators";
import {AngularFireAuth} from "@angular/fire/auth";
import {EventManagerService} from "../services/event-manager.service";
import {AccountManagerService} from "../services/account-manager-service";

@Injectable({
  providedIn: 'root'
})
export class PublicTrainingGuard implements CanActivate {

  constructor(
    private eventManagerService: EventManagerService,
    private accountManagerService: AccountManagerService,
    private router: Router,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const eventId = next.paramMap.get('training-room');
    const roomAccessCode = localStorage.getItem('access-code');
    const firstName = localStorage.getItem('name');
    const lastName = localStorage.getItem('surname');

    if (roomAccessCode) {

      // Request anonymous login
      return new Promise(async (resolve, reject) => {

        await this.accountManagerService.loginAnonymous(firstName, lastName);

        /* Check if provided event is public, event is not ended yet and access code is accepted */
        const event = await this.eventManagerService.getEvent(eventId);
        let result = event.isPublic && event.endAt > Date.now() && event.accessCode == roomAccessCode;

        /* Conditions to access training not met */
        if (!result) {
          await this.router.navigate([`training/${eventId}/access-code`], { queryParams: { 'error': true } });
        }

        resolve(result);

      });

    } else {

      return new Promise(async (resolve, reject) => {

        // If not logged in, or is anonymous, or is not expert or admin
        if (!(await this.accountManagerService.isLoggedIn()) || this.accountManagerService.account.isAnonymous || !this.accountManagerService.isAdminOrExpert()) {

          // Ask for code
          this.router.navigate([`training/${eventId}/access-code`]);

        } else {

          // Go to internal training
          this.router.navigate([`internal-training/${eventId}`])

        }

      });

    }

  }

}
